<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <div class="px-4">
        <date-interval name="Дата создания" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo"/>
        
        <user-autocomplete-multiple name="Клиенты" :select.sync="filter.usersSelected" selectAllEnabled/>
        
        <user-autocomplete-multiple name="Специалисты" _type="spec" :select.sync="filter.usersSpecSelected" selectAllEnabled/>
        
        <text-field name="Название" :value.sync="filter.mediaName"/>

        <autocomplete-multiple name="Категория" :items.sync="mediaDirs" :select.sync="filter.mediaDirsSelected" textOverflow/>

        <checkbox-field class="mb-4" name="Только справка в налоговую" :value.sync="filter.onlyTaxDeduction"/>
      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
        v-if="mediaDirsState.isSuccess"
        ref="table"
        :genRequestBuilder="genRequestBuilder"
        :height="height"
        :headers.sync="headers"  
        settingsKey="mediaTableSettings"
      >
      <template v-slot:item="{ item }">
          <tr @click="mediaId=item.id; mediaUser = item.user;">
            <template v-for="header in headers">
          
              <td v-if="header.value === 'id'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">{{item.id}}</td>
              
              <td v-if="header.value === 'name'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                {{item.name}}
                <tooltip v-if="item.status==='unactive'" bottom>
                  <v-icon small class="ml-2">mdi-file-alert</v-icon>
                  <template v-slot:content>
                    Черновик
                  </template>
                </tooltip>
              </td>
              
              <td v-if="header.value === 'comment'&&header.visible" :key="'td_'+header.value" >{{item.comment}}</td>

              <td v-if="header.value === 'user.lastName'&&header.visible" :key="'td_'+header.value">
                <UserFullName :user="item.user" short/>
              </td>
              
              <td v-if="header.value === 'userAuthor.lastName'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                <UserFullName :user="item.userAuthor" type="spec" avatar short/>           
              </td>

              <td v-if="header.value === 'created'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">{{$tools.dateTime(item.created)}}</td>

              <td v-if="header.value === 'isSent'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                <chip v-if="item.isSent" color="green" dark small fullWidth>Отправлено</chip>
              </td>

              <td v-if="header.value === 'actionBtns'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                  <MediaActions :item="item" :loading="loadState.isLoading" @load="$refs.table.load()" @mediaPreview="(v)=>mediaId=v"/>
              </td>
            </template>
          </tr>
        </template>
      </n-table-view>

      <media-view :media-id.sync="mediaId" :user-id="mediaUser?.id" :userName="mediaUser && $tools.userFullName(mediaUser)" @updateList="$refs.table.load()"/>



    </template>
  </layout-view>
</template>

<script>

import Api from "@/Api";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import State from "@/plugins/state";
import moment from "moment";
import LayoutView from "@/components/LayoutView";
import MediaView from "@/views/Media/MediaView";
import NTableView from "@/componentsV2/base/NTableView.vue";
import axios from "axios";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import MediaActions from "@/componentsV2/base/MediaActions.vue";


import {
  Entity_Media,
  Entity_User,
  Entity_MediaDir,
} from "../../../EntityStoreCacheService";


export default {
  components: {
    AutocompleteMultiple,
    LayoutView,
    NTableView,
    DateInterval,
    UserAutocompleteMultiple,
    MediaView,
    TextField,
    CheckboxField,
    Tooltip,
    Chip,
    UserFullName,
    MediaActions
  },
  props: ['userSpecDesktop'],
  data:()=>({
    loadState: new State(),
    mediaDirsState: new State(),

    filter:{
      dateFrom: moment(new Date()).format('DD.MM.YYYY'),
      dateTo: moment(new Date()).format('DD.MM.YYYY'),
      usersSelected: [],
      usersSpecSelected:[],
      mediaName: null,
      mediaDirsSelected:[],
      onlyTaxDeduction: false
    },

    headers: [
      { text: 'ID', value: 'id', sortable: true, class:'text-no-wrap', width:'auto', visible: true},
      { text: 'Название', value: 'name', sortable: true, class:'text-no-wrap', visible: true},
      { text: 'Комментарий', value:'comment', sortable: false, visible: true},
      { text: 'Клиент', value: 'user.lastName', sortable: true, class:'text-no-wrap', visible: true},
      { text: 'Автор', value: 'userAuthor.lastName', sortable: true, class:'text-no-wrap', visible: true},
      { text: 'Дата создания', value: 'created', sortable: false, class:'text-no-wrap', visible: true},
      { text: 'Отправка на Email', value:'isSent', sortable: false, visible: true},
      { text: '', value:'actionBtns',sortable: false, visible: true},
    ],

    mediaId: null,
    mediaUser:null,

    mediaDirs: [],
  }),
  mounted(){
    // фильтр из localStorage
    const filterSettings = localStorage.getItem('mediaFilter');
    if (localStorage.mediaFilter!==undefined&&filterSettings!==null)
      this.filter = JSON.parse(filterSettings);

    this.loadMediaDirs();
  },
  watch:{
    filter: {
      handler() {
        //сохраняем фильтры в localStorage
        localStorage.setItem('mediaFilter', JSON.stringify(this.filter));
        this.$refs?.table?.load();
      },
      deep: true,
    },
  },
  methods:{
    loadMediaDirs(){
      this.mediaDirsState.stateLoading();
      let mediaDir = new Entity_MediaDir()
      .selects(Entity_MediaDir.id)
      .selects(Entity_MediaDir.name)
      .selects(Entity_MediaDir.des)

      mediaDir.page(1).onPage(3000);
      mediaDir.order(Entity_MediaDir.sort, true)
      mediaDir.addStateCallback((v)=>{this.mediaDirsState.setRequestBuilderState(v)})
      mediaDir.request((data)=>{
        this.mediaDirs = data.items;
      }, (e)=>{
        console.error(e.response.data.message);
      })
    },
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_Media()
        .selects(Entity_Media.id)
        .selects(Entity_Media.created)
        .selects(Entity_Media.isSent)
        .selects(Entity_Media.isPrinted)
        .selects(Entity_Media.isShowInService)
        .selects(Entity_Media.name)
        .selects(Entity_Media.status)
        .selects(Entity_Media.fileName)
        .selects(Entity_Media.type)
        .selects(Entity_Media.path)

        //user
        .selects([Entity_Media.user,Entity_User.id].join('.'))
        .selects([Entity_Media.user,Entity_User.firstName].join('.'))
        .selects([Entity_Media.user,Entity_User.lastName].join('.'))
        .selects([Entity_Media.user,Entity_User.secondName].join('.'))

        //user
        .selects([Entity_Media.userAuthor, Entity_User.id].join('.'))
        .selects([Entity_Media.userAuthor, Entity_User.firstName].join('.'))
        .selects([Entity_Media.userAuthor, Entity_User.lastName].join('.'))
        .selects([Entity_Media.userAuthor, Entity_User.secondName].join('.'))
        .selects([Entity_Media.userAuthor, Entity_User.imageUrl].join('.'))

        .filterAnd([Entity_Media.entity, Entity_Media.status].join('.')+'!=?','deleted')

        // filter by created
        if(this.filter.dateFrom)
          rb.filterAnd([Entity_Media.entity, Entity_Media.created].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
        

        if(this.filter.dateTo) 
          rb.filterAnd([Entity_Media.entity, Entity_Media.created].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
        

        // filter by user
        if (this.filter.usersSelected?.length)
          rb.filterAnd([Entity_Media.entity, Entity_Media.user, Entity_User.id ].join('.')+' in (?)',this.filter.usersSelected.map(i=>i.id))
        

        // filter by userSpec
        if (this.filter.usersSpecSelected?.length)
          rb.filterAnd([Entity_Media.entity, Entity_Media.userAuthor, Entity_User.id ].join('.')+' in (?)',this.filter.usersSpecSelected.map(i=>i.id))
        

        //filter by media тame
        if (this.filter.mediaName!==null&&this.mediaName!=='')
          rb.filterAnd([Entity_Media.entity, Entity_Media.name].join('.')+' LIKE ?','%'+this.filter.mediaName+'%');
        

        //filter by mediaDir
        if (this.filter.mediaDirsSelected?.length)
           rb.filterAnd([Entity_Media.entity, Entity_Media.mediaDir, Entity_MediaDir.id].join('.')+' in (?)',this.filter.mediaDirsSelected.map(i=>i.id));

        //filter by tax deduction
        if (this.filter.onlyTaxDeduction)
          rb.filterAnd([Entity_Media.entity, Entity_Media.type].join('.')+' =?','taxDeduction');
  

        sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
        })
        
        return rb;
    },
    misDesktopOpenFile(v){
      axios.get(Api.host + '/media/media/' + v.id + '/').then(r1 => {
        let mediaData = r1.data;
        this.$tools.misDesktopOpenFile(
            mediaData.path,
            mediaData.name + mediaData.path.substring(mediaData.path.lastIndexOf('.')),
            "https://"+window.location.hostname+"/api/media/media/upload/desktop/",
            {
              id: v.id,
            },
            ()=>{
              this.$store.commit('alertSuccess', 'Файл открывается локально');
            }, ()=>{
              this.$store.commit('alertError', 'Не удалось открыть файл локально');
            }
        );
      });
    },
  }
}
</script>